module.exports = __webpack_public_path__ + "img/logo_full.4868a628.png";